import { useState, useEffect, useCallback } from 'react';
import { ApiService } from '../services/api';

export function useSession() {
  const [deviceId] = useState<string>(() => {
    let id = localStorage.getItem('mehfil_device_id');
    if (!id) {
      id = 'dev_' + Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
      localStorage.setItem('mehfil_device_id', id);
    }
    return id;
  });

  const [sessionId, setSessionId] = useState<string>(() => {
    return localStorage.getItem('mehfil_session_id') || '';
  });

  const [sessionData, setSessionData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const initSession = useCallback(async () => {
    try {
      setIsLoading(true);
      const existingSessionId = localStorage.getItem('mehfil_session_id') || undefined;
      const res = await ApiService.initSession(deviceId, existingSessionId);
      if (res?.session?.id) {
        setSessionId(res.session.id);
        setSessionData(res.session);
        localStorage.setItem('mehfil_session_id', res.session.id);
      }
    } catch (e) {
      console.error('[useSession] Initialization error:', e);
    } finally {
      setIsLoading(false);
    }
  }, [deviceId]);

  const resumeByToken = useCallback(async (token: string) => {
    try {
      setIsLoading(true);
      const res = await ApiService.resumeSession(token, deviceId);
      if (res?.session?.id) {
        setSessionId(res.session.id);
        setSessionData(res.session);
        localStorage.setItem('mehfil_session_id', res.session.id);
        return res.session;
      }
    } catch (e) {
      console.error('[useSession] Resume error:', e);
      throw e;
    } finally {
      setIsLoading(false);
    }
  }, [deviceId]);

  useEffect(() => {
    initSession();
  }, [initSession]);

  return {
    deviceId,
    sessionId,
    sessionData,
    isLoading,
    refreshSession: initSession,
    resumeByToken
  };
}
